module.exports = __webpack_public_path__ + "img/gzh.fd477f25.png";